import {SignInResponse} from "./types";

export class SignIn {
    private static readonly endpoint: string = `${document.location.origin}/api/user/sign-in`;

    public static async signIn(
      strategy: string,
      step: string,
      formData: FormData | null = null,
      captchaToken: string | null = null
    ): Promise<SignInResponse> {
        const requestData: Record<string, string> = {
            strategy: strategy,
            step: step,
        };

        if (captchaToken !== null) {
            requestData.captchaToken = captchaToken;
        }

        if (formData !== null) {
            for (const [key, value] of formData) {
                requestData[key] = value.toString();
            }
        }

        const response = await fetch(SignIn.endpoint, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(requestData),
        });

        if (!response.ok) {
            throw new Error(`Sign in is failed: ${response.statusText}`);
        }

        return await response.json();
    }
}